import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20sneaker%20collection%20displayed%20on%20modern%20acrylic%20risers%20against%20warm%20terracotta%20background%20wall%20creative%20product%20merchandising%20fashion%20retail%20display%20with%20dramatic%20side%20lighting%20and%20deep%20shadows%20contemporary%20boutique%20aesthetic%20editorial%20commercial%20photography%20with%20rich%20earthy%20tones%20and%20soft%20glow&width=1600&height=900&seq=kakobuy-hero-bg&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska produkty"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full mb-6">
              <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
              <span className="text-xs font-medium text-foreground-700">Aktualizacja 2026</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
              Kakobuy Spreadsheet Polska – Najprostszy sposób na znalezienie najlepszych produktów
            </h1>

            <p className="text-base md:text-lg text-background-100/90 leading-relaxed mb-8 max-w-xl">
              Odkrywaj najpopularniejsze produkty, porównuj kategorie, sprawdzaj informacje QC i korzystaj z aktualnego Kakobuy Spreadsheet stworzonego dla polskich użytkowników.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
              >
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
                Sprawdź Kakobuy Spreadsheet
              </a>
              <Link
                to="/artykul/kakobuy-spreadsheet-poradnik"
                className="inline-flex items-center gap-2 px-6 py-3.5 border-2 border-background-50/40 hover:border-background-50 text-background-50 font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm hover:bg-background-50/10"
              >
                <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
                Zobacz najnowsze poradniki
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-3 md:gap-4">
              <span className="flex items-center gap-1.5 text-xs text-background-100/80">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
                Aktualizowane listy produktów
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-100/80">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
                Poradniki dla początkujących
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-100/80">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
                Analizy kategorii
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-100/80">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
                Bezpieczeństwo zakupów
              </span>
            </div>
          </div>

          <div className="hidden lg:block animate-fade-in" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
            <div className="bg-background-50/15 backdrop-blur-md rounded-2xl p-6 border border-background-50/20">
              <div className="flex items-center gap-3 mb-5">
                <div className="flex gap-1.5">
                  <div className="w-3 h-3 rounded-full bg-red-400/60"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-400/60"></div>
                  <div className="w-3 h-3 rounded-full bg-green-400/60"></div>
                </div>
                <span className="text-xs text-background-100/70">Kakobuy Spreadsheet</span>
              </div>
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b border-background-50/20">
                    <th className="pb-2 text-xs font-semibold text-background-100/80">Produkt</th>
                    <th className="pb-2 text-xs font-semibold text-background-100/80">Kategoria</th>
                    <th className="pb-2 text-xs font-semibold text-background-100/80">Cena</th>
                    <th className="pb-2 text-xs font-semibold text-background-100/80">Ocena</th>
                    <th className="pb-2 text-xs font-semibold text-background-100/80">QC</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: 'Nike Dunk Low', cat: 'Shoes', price: '¥199', rating: '4.8', qc: '✓' },
                    { name: 'Essentials Hoodie', cat: 'Hoodies', price: '¥168', rating: '4.6', qc: '✓' },
                    { name: 'Carhartt Jacket', cat: 'Jackets', price: '¥289', rating: '4.9', qc: '✓' },
                    { name: 'Gallery Dept Tee', cat: 'T-Shirts', price: '¥89', rating: '4.5', qc: '✓' },
                    { name: 'Arc\'teryx Beta LT', cat: 'Jackets', price: '¥420', rating: '4.7', qc: '✓' },
                  ].map((item, i) => (
                    <tr key={i} className="border-b border-background-50/10">
                      <td className="py-2.5 text-xs text-background-100/90">{item.name}</td>
                      <td className="py-2.5 text-xs text-background-100/70">{item.cat}</td>
                      <td className="py-2.5 text-xs text-background-100/90">{item.price}</td>
                      <td className="py-2.5 text-xs text-accent-400">★ {item.rating}</td>
                      <td className="py-2.5 text-xs text-green-400">{item.qc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="w-10 h-10 flex items-center justify-center text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}